export default "__VITE_ASSET__0c807e3f__"